import type { Socket } from "socket.io-client";

export const leaveUserRoom = (socket: Socket, userId: string): void => {
  try {
    socket.emit("user:leave", { userId });
  } catch {}
};

export const joinUserRoom = (socket: Socket, userId: string): void => {
  try {
    socket.emit("user:join", { userId }, () => {});
  } catch {}
  try {
    const room = `user:${userId}`;
    socket.emit("join", room, () => {});
  } catch {}
};

export const wireUserPrefsDelta = (
  socket: Socket,
  deps: {
    onPatch: (patch: Record<string, unknown>, meta: { source?: string }) => void;
    sourceId: string;
  }
): (() => void) => {
  const { onPatch, sourceId } = deps;

  const handler = (payload: {
    patch?: Record<string, unknown>;
    patches?: unknown[];
    key?: string;
    value?: unknown;
    userPrefs?: Record<string, unknown>;
    sourceId?: string;
  }) => {
    try {
      if (!payload) return;
      if (payload.sourceId && payload.sourceId === sourceId) return;

      const candidatePatches: Record<string, unknown>[] = [];

      const pushPatch = (patch: unknown) => {
        if (patch && typeof patch === "object" && !Array.isArray(patch)) {
          candidatePatches.push(patch as Record<string, unknown>);
        }
      };

      if (payload.patch) pushPatch(payload.patch);
      if (payload.userPrefs) pushPatch(payload.userPrefs);

      if (Array.isArray(payload.patches)) {
        for (const entry of payload.patches) {
          if (
            entry &&
            typeof entry === "object" &&
            !Array.isArray(entry) &&
            Object.prototype.hasOwnProperty.call(entry, "key") &&
            Object.prototype.hasOwnProperty.call(entry, "value")
          ) {
            const key = (entry as any).key;
            if (typeof key === "string") {
              candidatePatches.push({ [key]: (entry as any).value });
            }
          } else {
            pushPatch(entry);
          }
        }
      }

      if (payload.key && typeof payload.key === "string") {
        candidatePatches.push({ [payload.key]: payload.value });
      }

      if (!candidatePatches.length) return;

      for (const patch of candidatePatches) {
        try {
          onPatch(patch, { source: "socket" });
        } catch {}
      }
    } catch {}
  };

  const eventName = "user:prefs:delta";
  try {
    socket.off(eventName, handler as any);
  } catch {}
  socket.on(eventName, handler as any);

  return () => {
    try {
      socket.off(eventName, handler as any);
    } catch {}
  };
};
